import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-90c06c6c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_c_button_group = _resolveComponent("c-button-group")
  const _component_c_table = _resolveComponent("c-table")
  const _directive_hasAuth = _resolveDirective("hasAuth")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_c_table, { dataSource: _ctx.tableConfig }, {
      action: _withId((scope) => [
        _createVNode(_component_c_button_group, {
          key: new Date().getTime(),
          len: 3
        }, {
          default: _withId(() => [
            _withDirectives(_createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (_ctx.cancel(scope.row))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.btnName('enterprise-info-disassociate') || '取消关联'), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]), [
              [_directive_hasAuth, 'enterprise-info-disassociate']
            ])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["dataSource"])
  ]))
})